<template>
  <div v-if="loading" class="spinner-container">
    <div class="spinner"></div>
  </div>
  <div v-else>
    <!-- Keep-alive should wrap <router-view /> -->

    <div class="homepage d-flex flex-column vh-100">
      <!-- navbar -->
      <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary">
        <div class="d-flex align-items-center">

          <span @click="goBack()" class="text-white"><i class="bi bi-arrow-left fs-5"></i></span> &nbsp; &nbsp;

          <span>
            <h4 class="text-white">{{language?.account_statement}}</h4>
          </span>

       

          <div class="d-flex align-items-center gap-2 ms-auto">

            <a href="#" class="link-dark text-truncate d-flex align-items-center gap-2" data-bs-toggle="offcanvas"
              data-bs-target="#orderDetailsCanvas" aria-controls="orderDetailsCanvas">
              <b class="bg-white   rounded-circle user-icon">
                <i class="bi bi-filter  d-flex m-1 h4 text-dark"></i>
              </b>
            </a>
          </div>

          
         
        </div>




      </div>

      <!-- body -->
      <div class="my-auto overflow-auto vh-100">
         <div class="container bg_card  ">

          <div class="  pt-2 row">
            <div class="col-12 pb-1">
                <input type="text" v-model="search_txt" :placeholder="language?.search_cust_or_emp" class="form-control"> 
               <div class="Row mt-2">
                <span  :class="currently_showing=='cust'?'badge bg-danger':'badge bg-success'"  @click="filterhistory('cust')">
                    <i class="bi bi-plus"></i> &nbsp; cust
                  </span> &nbsp; &nbsp;
                  <span  :class="currently_showing=='emp'?'badge bg-danger':'badge bg-success'"  @click="filterhistory('emp')">
                    <i class="bi bi-plus"></i> &nbsp; emp
                  </span> &nbsp; &nbsp;
                  <span :class="currently_showing=='all'?'badge bg-danger':'badge bg-success'" @click="filterhistory('all')">
                    <i class="bi bi-plus"></i> &nbsp; all
                  </span> &nbsp; &nbsp;
              </div>
              
            </div>
            <div class="  border-1 overflow-hidden col-12" v-for="(account,i) in filtereaccountingList">

             
                <div class="card card-body p-1">
                 <div class="text-muted">Tr NO. #{{account.id}}  <span class="float-right">{{ language?.date }}: {{account.billdate}}</span></div>
                 
                 <div class="text-dark">
                    <strong>
                      {{ account.employee_name ? account.employee_name : account.customer_name }}
                    </strong>
                    <span class="text-muted">
                      ({{ account.employee_name ? 'Employee' : 'Customer' }})
                    </span>
                  </div>
                                  
              <div class="text-muted">{{account.remark}}</div>  
              <div class="row mt-2">
                <div class="col-4" style="color: black;">{{ language?.total }}</div>
                <div class="col-4" style="color: black;">{{ language?.paid }}</div>
                <div class="col-4" style="color: black;">{{ language?.due }}</div>
       


                <div class="col-4" style="color: red;"> {{account.total}}</div>
                <div class="col-4" style="color: red;">  {{account.paid}}</div>
                <div class="col-4" style="color: red;"> {{ account.total - account.paid }}</div>
  
            </div>  
            
              <div>
                <router-link :to="'/singleaccounting?id='+(account.userid>0?account.userid:account.custid)+'&user_type='+(account.employee_name ? 'Employee' : 'Customer')" >
                <span class="badge bg-success">
                  <i class="bi bi-eye"></i> &nbsp; View 
                </span> &nbsp; &nbsp;
            </router-link>
            <span class="badge btn-primary" @click="addvoucher(account)">
                <i class="bi bi-plus"></i> &nbsp; Edit
              </span> &nbsp; &nbsp;

              <span class="badge bg-danger" @click="deleteaccounting(account.id)"><i class="bi bi-trash"></i> &nbsp; Delete</span>&nbsp; &nbsp; 

              </div>

            

            </div> 
            
            </div>
         </div>
          </div>
             
 







      </div>
  
      <div class="offcanvas offcanvas-bottom custom_height border-0" tabindex="-1" id="orderDetailsCanvas"
      aria-labelledby="orderLabel">
      <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
        <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i
            class="bi bi-arrow-left fs-5 text-white"></i></a>
        <h6 class="offcanvas-title text-white m-0" id="orderLabel">Filter</h6>
      </div>
      <div class="offcanvas-body">
        <div class="col-12 row">
          <!-- Radio Buttons -->
          <div class="col-12 mb-2">
            <label class="form-label">Filter By:</label>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="radioCustomer"
                value="customer"
                v-model="filterType"
              />
              <label class="form-check-label" for="radioCustomer">Customer</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="radioEmployee"
                value="employee"
                v-model="filterType"
              />
              <label class="form-check-label" for="radioEmployee">Employee</label>
            </div>
          </div>
        
          <div class="col-6">
            <label class="form-label">From Date</label>
            <input type="date" v-model="filter.fromdate" class="form-control" />
          </div>
        
          <div class="col-6">
            <label class="form-label">To Date</label>
            <input type="date" v-model="filter.todate" class="form-control" />
          </div>
        
          <!-- Customer Dropdown (Visible if Customer is selected) -->
          <div class="col-12 mt-2" v-if="filterType === 'customer'">
            <label>Customer Name</label>
            <select class="form-select form-select-sm" v-model="filter.cust_id">
              <option value="0" disabled selected>{{ language?.select_cutomer }}</option>
              <option v-for="(item, index) in customerlist" :key="index" :value="item.id">
                {{ item.name }}
              </option>
            </select>
            <span class="text-danger">{{ duelabel }}</span>
          </div>
        
          <!-- Employee Dropdown (Visible if Employee is selected) -->
          <div class="col-12 mt-2" v-if="filterType === 'employee'">
            <label>Employee Name</label>
            <select class="form-select form-select-sm" v-model="filter.empid">
              <option value="0" disabled selected>{{ language?.select_employee }}</option>
              <option v-for="(item, index) in employeelist" :key="index" :value="item.id">
                {{ item.name }}
              </option>
            </select>
            <span class="text-danger">{{ duelabel }}</span>
          </div>
        
          <div class="offcanvas-footer">
            <button class="btn btn-success col-12" @click="filterallaccountingList">
              <i class="bi bi-check"></i> &nbsp;Filter
            </button>
          </div>
        </div>
        
  </div>
          
    
    </div>
   
<!-- edit  -->

<!-- voucher canvas -->
<div class="offcanvas offcanvas-end border-0" tabindex="-1" id="showvoucher" aria-labelledby="voucherLabel">
    <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
       <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i class="bi bi-arrow-left fs-5 text-white"></i></a>
       <h6 class="offcanvas-title text-white m-0" id="voucherLabel">Add Voucher</h6>
    </div>
    <div class="offcanvas-body">
      
           
               <div class="mb-3">
                   <label for="date" class="form-label">Date</label>
                   <input type="date" id="date" v-model="voucher.billdate" class="form-control" required>
               </div>

               <div class="mb-3">
                <label for="amount" class="form-label">Amount</label>
                <input type="number" id="amount" v-model="voucher.paid" class="form-control" required>
            </div>

            <div class="mb-3">
                <label for="remark" class="form-label">Remark</label>
                <textarea id="remark" v-model="voucher.remark" class="form-control" rows="2" required></textarea>
            </div>
            
               
             <div class="d-flex gap-2">
                <button class="btn btn-primary w-100 " @click="updatevoucher">Save</button>
               
             </div>
            
    </div>
 </div>





    
    </div>
  </div>
</template>
<style>
.float-right{
    float: right;
}
.bottom_border{
        border-bottom: 1px solid gray;
}
.footer_area{
        position: fixed;
        width: -webkit-fill-available;
        bottom: 0;
        background: aliceblue;
        padding: 5px 10px;
}
    .custom_height {
           min-height: 80vh;
        max-height: 80vh;
        overflow-y: auto;
    }
</style>
<script>
import axios from "@/plugins/axios";
import { reactive } from "vue";

  export default {
    name: 'Branch',
    components: {
    },
    
    
    mounted() {
      //  this.fetchWeather();
      this.getNewOrderBasics(); // Call the method here

    },
    watch: {
      search_txt(newVal) {
        this.filtereaccountingList = this.accountingList.filter((item) =>
        (item.employee_name?.toLowerCase() || '').includes(newVal.toLowerCase()) || 
        (item.customer_name?.toLowerCase() || '').includes(newVal.toLowerCase())
        );
      },
       
    },
    data() {
      return { 
        filterType: "customer", // Default selection
        loading: false,
        error: null,
        isUserLogged: false,
        user_details: [],
        accountingList: [],
        productsCostList: [],
        filteredproductsCostList: [],
        filtereaccountingList: [],
        selected: [],
        customers: [],
        customerlist:[],
        employeelist:[],
        language:this.getLocalStorageArray('lang'),
        selected_services: {},
        order_products_services: {},
        currently_showing:'all',
        
        filter:{
          empid:0,
          cust_id:0,
          fromdate:new Date().toISOString().split('T')[0],
          todate:new Date().toISOString().split('T')[0],
        },

        customer:{
          name:'',
          contact:'',
          address:'',
        },

        voucher:{
        id:'',
        billdate:new Date().toISOString().split('T')[0],
        paid:'',
        remark:'',
        userid:0

      },


        
        search_txt: '',

      }
    },
    methods: {
      initializeHomeContent() {


      },
      deleteaccounting(id = "") {
      this.loading = true;
      this.error = null;

    try {
        var self = this;

        this.$swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post("deleteaccounting", { id: id }).then((response) => {
                    self.accountingList = response.data.acountinglist;
                    self.filtereaccountingList = self.accountingList; 
                    self.$swal.fire(response.data.message);
                   
                }).then(() => {
                    
                    
                    self.initializeHomeContent();
                }).catch((err) => {
                    self.$swal.fire("Error!", "Something went wrong.", "error");
                });
            }
        });

    } catch (err) {
        this.error = err.response?.data?.message || "Login failed. Please try again.";
    } finally {
        this.loading = false;
    }
},

      addvoucher(account) {
        
        window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("showvoucher")).show();
         this.voucher=account;
         
     }, 



      editBranch(editBranch) {
         window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).show();
        //  this.branch=editBranch;
      },
      goBack() {
          
          this.$router.go(-1);
  },

        
getLocalStorageArray(key) {
        let data = localStorage.getItem(key);
        try {
            return data ? JSON.parse(data) : [];
        } catch (e) {
            console.error("Error parsing localStorage data", e);
            return [];
        }
    },
    
             
      async getNewOrderBasics() {
        this.loading = true;
        this.error = null;

        try {
          var self = this;
          axios.post("getaccountinghistory").then((response) => {
            self.productsCostList = response.data.cost;
            self.servicesList = response.data.servicesLists;
            self.accountingList = response.data.acountinglist;
            self.customerlist = response.data.customerlist;
            self.employeelist = response.data.employeeList;
            self.filtereaccountingList = self.accountingList; 
            self.language=response.data.language;
            localStorage.setItem('lang',response.data.language);

          }).then(() => {
            self.initializeHomeContent();

            $("#customers").select2({
              width: '100%',
              placeholder: "Search Services Here...",
              "language": {
                "noResults": function () {
                  return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                }
              },
              escapeMarkup: function (markup) {
                return markup;
              }
            }).on('change', function (event) {
                self.filter.cust_id= $(this).val(); 
                
            });



            $("#employee").select2({
              width: '100%',
              placeholder: "Search Employee Here...",
              "language": {
                "noResults": function () {
                  return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                }
              },
              escapeMarkup: function (markup) {
                return markup;
              }
            }).on('change', function (event) {
                self.filter.empid= $(this).val(); 
                
            });







          }).catch((err) => {

          });;











          

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      },

 
  

      filterallaccountingList() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("filterallaccountingList",self.filter).then((response) => {
               
                self.accountingList = response.data.acountinglist;
                self.filtereaccountingList = self.accountingList; 

                       window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("orderDetailsCanvas")).hide();
                      

               
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 

      updatevoucher() {
    this.loading = true;
    this.error = null;

    try {
        var self = this;
        if (self.voucher.userid < 0) {
            self.$swal.fire("Empty Customer");
        } else if (self.voucher.amount == '') {
            self.$swal.fire("Amount is empty");
        } else {
            axios.post("updateuservoucherdata", self.voucher).then((response) => {
                self.accountingList = response.data.acountinglist;
                self.filtereaccountingList = self.accountingList; 
                // self.customerlist = response.data.customerlist;
                // self.filteredcustomerList = self.customerlist; 

                 self.$swal.fire(response.data.message);
                if (response.data.success) {
                    self.voucher = { voucher_date: '', amount: '', remark: '', custid: 0 };
                }
                
                window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("showvoucher")).hide();
            }).then(() => {
                self.initializeHomeContent();
            });
        }
    } catch (error) {
        console.error(error);
        self.$swal.fire("An error occurred while saving the voucher.");
    } finally {
        this.loading = false;
    }
},


async filterhistory(what) {
        this.loading = true;
        this.error = null;
        this.currently_showing=what;
        if(what=="cust")
            this.filtereaccountingList = this.accountingList.filter((item) =>
                item.custid>0
            );
        else if(what=="emp")
            this.filtereaccountingList = this.accountingList.filter((item) =>
                item.userid>0
            );
        else if(what=="all")
            this.filtereaccountingList = this.accountingList;
        else
        this.filtereaccountingList = this.accountingList;
        
            this.loading = false;
        // try {
        //   var self = this;
        //   axios.post("filtertrhistory").then((response) => {
        //     self.productsCostList = response.data.cost;
        //     self.servicesList = response.data.servicesLists;
        //     self.accountingList = response.data.acountinglist;
        //     self.filtereaccountingList = self.accountingList; 

        //   }).then(() => {
        //     self.initializeHomeContent();

        //     $("#customers").select2({
        //       width: '100%',
        //       placeholder: "Search Services Here...",
        //       "language": {
        //         "noResults": function () {
        //           return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
        //         }
        //       },
        //       escapeMarkup: function (markup) {
        //         return markup;
        //       }
        //     }).on('change', function (event) {
        //         self.order.cust_id= $(this).val(); 
                
        //     });
        //   }).catch((err) => {

        //   });;


        // } catch (err) {
        //   this.error = err.response?.data?.message || "Login failed. Please try again.";
        // } finally {
        //   this.loading = false;
        // }
      },
      
getLocalStorageArray(key) {
     let data = localStorage?.getItem(key);
     try {
         return data ? JSON.parse(data) : [];
     } catch (e) {
         console.error("Error parsing localStorage data", e);
         return [];
     }
 }





    }
  }






</script>